import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import LogoKTS2 from "../assets/imgs/logo_kts2.png";
import {
  IconButton,
  SwipeableDrawer,
  Divider,
  List,
  ListItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { ChevronRight } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// navigationLinks 뒤에 언어 선택기 추가
const languages = [
  { code: "en", label: "ENG" },
  { code: "it", label: "ITA" },
  { code: "es", label: "ESP" },
];

const Topbar = ({
  gotoTop,
  gotoServiceSection,
  gotoStorySection,
  gotoVisionSection,
  gotoGallerySection,
  gotoExperiencesSection,
  gotoCompanyInfo,
}) => {
  const { t, i18n } = useTranslation();
  const currentLabel = languages.find(l => l.code === i18n.language)?.label ?? "ENG";

  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [topbarBgToggle, setTopbarBgToggle] = useState(false);

  const localCss = {
    fontSize: 15,
    fontColor: "#4E5968",
    letSpacing: -0.1,
  };

  const navigationLinks = [
    { name: t("nav.itineraries"), onclick: gotoGallerySection, type: "itineraries" },
    { name: t("nav.experiences"), onclick: gotoExperiencesSection, type: "experiences" },
    { name: t("nav.story"), onclick: gotoStorySection, type: "story" },
    { name: t("nav.contact"), onclick: gotoCompanyInfo, type: "contact" },
  ];

  const gotoIndex = () => {
    navigate("/");
  };

  const topSubMenusToggle = (e) => {
    const thisTag = e.target.nextSibling;
    thisTag.classList.toggle("hidden");
    thisTag.classList.toggle("flex");
  };

  const subMenusToggle = (e) => {
    const thisTag = e.target.parentNode;
    thisTag.classList.toggle("hidden");
    thisTag.classList.toggle("flex");
  };

  const curScreenLocation = () => {
    if (window.innerWidth > 767) {
      window.scrollY >= 100 ? setTopbarBgToggle(true) : setTopbarBgToggle(false);
    } else {
      window.scrollY > 199 ? setTopbarBgToggle(true) : setTopbarBgToggle(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", curScreenLocation, { capture: true });
    return () => {
      window.removeEventListener("scroll", curScreenLocation);
    };
  }, []);

  const GlobeIcon = ({ color = "#F7F8F9" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><path fill={color} d="M10 1.25c.289 0 .606.146.966.538.363.39.729 1.012 1.04 1.811.293.746.529 1.65.706 2.651H7.287c.178-1 .414-1.905.707-2.651.311-.798.678-1.421 1.04-1.813.36-.389.677-.536.966-.536zm-2.375.333c-.3.45-.565.97-.796 1.562a15.498 15.498 0 0 0-.82 3.105H2.1a8.748 8.748 0 0 1 5.525-4.667zm4.75 0A8.73 8.73 0 0 1 17.9 6.25h-3.909a15.498 15.498 0 0 0-.82-3.105 8.204 8.204 0 0 0-.796-1.562zM1.616 7.5h4.243c-.092.83-.14 1.665-.144 2.5 0 .87.06 1.696.144 2.5H1.616A8.779 8.779 0 0 1 1.25 10c0-.87.131-1.707.366-2.5zm5.503 0h5.762c.089.797.154 1.625.154 2.5s-.065 1.7-.154 2.5H7.119c-.089-.8-.154-1.625-.154-2.5s.065-1.703.154-2.5zm7.021 0h4.244c.235.793.366 1.63.366 2.5 0 .87-.131 1.707-.366 2.5H14.14c.085-.804.145-1.63.145-2.5 0-.87-.06-1.697-.145-2.5zM2.103 13.75h3.906c.19 1.158.469 2.21.82 3.108.23.591.495 1.108.794 1.557a8.746 8.746 0 0 1-5.52-4.665zm5.187 0h5.42c-.176 1-.413 1.909-.704 2.654-.311.799-.679 1.42-1.04 1.812-.36.39-.677.534-.966.534-.289 0-.606-.144-.966-.535-.363-.391-.729-1.012-1.04-1.811-.292-.745-.528-1.654-.704-2.654zm6.701 0h3.906a8.745 8.745 0 0 1-5.52 4.665 8.18 8.18 0 0 0 .794-1.557c.35-.898.63-1.95.82-3.108z" /></svg>
  );

  return (
    <div
      className={`fixed w-full z-[200] ${topbarBgToggle ? "bg-white shadow-sm border-b" : "bg-transparent"}`}
    >
      <div className="flex justify-between px-[10vw] md:px-[10px] md:justify-between font-[Paperozi]">
        <div className="flex select-none">
          <button onClick={gotoTop ? gotoTop : gotoIndex}>
            <div className="flex flex-row items-center">
              <img
                src={LogoKTS2}
                alt="logo"
                variant="h6"
                className="h-10 my-2"
              />
              <div className={`text-center ${topbarBgToggle ? "text-[#202632]" : "text-[white]"} font-bold`}>KTS</div>
            </div>
          </button>
          <div className="flex items-center ml-4 gap-1 cursor-pointer group relative">
            <GlobeIcon color={topbarBgToggle ? "#4E5968" : "#FFFFFF"} />
            <span className={`${topbarBgToggle ? "bg-white" : "bg-transparent"}`} style={{ color: topbarBgToggle ? localCss.fontColor : "#FFFFFF", fontSize: 13, fontWeight: 600 }}>
              {currentLabel}
            </span>

            <div className="hidden group-hover:flex flex-col absolute top-full left-0 bg-white rounded-lg py-1 min-w-[80px]">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 text-left"
                  onClick={() => i18n.changeLanguage(lang.code)}
                >
                  {lang.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="flex">
          <div className="md:hidden flex font-[Paperozi]">
            {navigationLinks.map((item, idx) => (
              <React.Fragment key={idx}>
                <Button
                  className="cursor-pointer"
                  variant="text"
                  color="inherit"
                  style={{
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    fontSize: localCss.fontSize,
                    color: topbarBgToggle ? localCss.fontColor : "#FFFFFF",
                  }}
                  onClick={(event) => {
                    if (!item.onclick) {

                    } else {
                      item.onclick();
                    }

                    if (item.subMenus) {
                      topSubMenusToggle(event);
                    }
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>{item.name}</span>
                </Button>
                {item.subMenus ? (
                  <div className="bg-white py-1 border-y-2 hidden absolute w-full top-20 left-0">
                    {item.subMenus.map((jtem, jdx) => {
                      return (
                        <button
                          key={jdx}
                          className="hover:bg-zinc-100 hover:opacity-80 hover:text-gray-500 font-semibold text-gray-500 px-1 flex w-full justify-center py-2 rounded-lg"
                          onClick={(event) => {
                            subMenusToggle(event);
                            jtem.onclick();
                          }}
                        >
                          {jtem.name}
                        </button>
                      );
                    })}
                  </div>
                ) : (
                  ""
                )}
              </React.Fragment>
            ))}
          </div>
          <div className="hidden md:flex">
            <button
              className="flex text-coolGray-500 items-center"
              onClick={() => {
                setMenuOpen(true);
              }}
            >
              <MenuIcon style={{ width: 35, height: 35 }} />
            </button>
          </div>
        </div>
      </div>
      {/* 모바일 화면에서 메뉴 */}
      <SwipeableDrawer
        anchor="right"
        open={menuOpen}
        onOpen={() => setMenuOpen(true)}
        onClose={() => {
          setMenuOpen(false);
        }}
      >
        <IconButton
          onClick={() => {
            setMenuOpen(false);
          }}
        >
          <ChevronRight />
        </IconButton>
        <Divider />
        <List>
          {navigationLinks.map((item, idx) => (
            <ListItem key={idx} className="flex flex-col">
              <Button
                key={idx}
                variant="text"
                color="inherit"
                style={{
                  textTransform: "none",
                  fontWeight: localCss.fontWeight,
                  fontSize: localCss.fontSize,
                  color: localCss.fontColor,
                  fontFamily: localCss.fontFamily,
                  marginBottom: 6,
                }}
                onClick={(event) => {
                  if (!item.onclick) {

                  } else {
                    item.onclick();
                  }
                }}
              >
                {item.name}
              </Button>
              {item.subMenus ? (
                <div className="w-full border-t-2 border-b-2 py-1">
                  {item.subMenus.map((jtem, jdx) => {
                    return (
                      <button
                        key={jdx}
                        className="hover:bg-zinc-100 hover:opacity-80 hover:text-gray-500 font-semibold text-gray-500 px-1 flex w-full justify-center py-2 rounded-lg"
                        onClick={(event) => {
                          jtem.onclick();
                          setMenuOpen(false);
                        }}
                      >
                        {jtem.name}
                      </button>
                    );
                  })}
                </div>
              ) : (
                ""
              )}
            </ListItem>
          ))}
        </List>
      </SwipeableDrawer>
    </div>
  );
};

export default Topbar;
